import { combineReducers } from 'redux';

import theme from './theme';

export const rootReducer = combineReducers({
	theme,
});
